<template>
    
    <div class="main">
        <c-panel>
            <form-permissao :paramId="$route.params.id" v-on:onSubmitPermissao="onSubmitPermissao"></form-permissao>
        </c-panel>
    </div>
    
</template>
<script>

import formPermissao from "./form"

export default {
    methods:{
        onSubmitPermissao(){
            this.$router.push('/admin/permissao');  
        }
    },
    components:{ formPermissao }
}
</script>

